import * as THREE from 'three';
import { gsap } from 'gsap';

export const setupEnvironment = (scene, cinematicMode = false) => {
  // Set background based on cinematic mode
  const textureLoader = new THREE.TextureLoader();
  
  if (cinematicMode) {
    const cinemaTexture = textureLoader.load('./Cinema.jpeg');
    scene.background = cinemaTexture;
  } else {
    const tvTexture = textureLoader.load('./TV Back.jpeg');
    scene.background = tvTexture;
  }
  
  // Create TV screen boundaries (invisible helper for constraining spheres)
  const screenBounds = {
    width: 6,
    height: 4,
    centerX: 0,
    centerY: 2,
    centerZ: -5
  };

  // Remove fog for clear TV background visibility
  scene.fog = null;

  return {
    screenBounds
  };
};